import { Button } from '@/components/ui/button';
import { Minus, Plus } from 'lucide-react';

const MAX_GUESTS = 4;

interface GuestCountStepperProps {
  count: number;
  max?: number;
  onChange: (count: number) => void;
}

export function GuestCountStepper({ count, max = MAX_GUESTS, onChange }: GuestCountStepperProps) {
  const maxGuests = Math.max(0, Math.min(MAX_GUESTS, max));
  return (
    <div className="flex items-center justify-between gap-3">
      <div>
        <p className="text-sm font-medium text-foreground">Guests</p>
        <p className="text-xs text-muted-foreground">
          {maxGuests === 0 ? 'No guest spots remaining' : `Add up to ${maxGuests} guests`}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          size="icon-sm"
          aria-label="Remove guest"
          disabled={count <= 0}
          onClick={() => onChange(Math.max(0, count - 1))}
        >
          <Minus className="size-4" />
        </Button>
        <span className="min-w-6 text-center text-sm font-semibold tabular-nums">{count}</span>
        <Button
          type="button"
          variant="outline"
          size="icon-sm"
          aria-label="Add guest"
          disabled={count >= maxGuests}
          onClick={() => onChange(Math.min(maxGuests, count + 1))}
        >
          <Plus className="size-4" />
        </Button>
      </div>
    </div>
  );
}

export { MAX_GUESTS };
